import styled from '@emotion/styled'

import { MenuItem } from '@tranzact/platform_react-components'

export default styled(MenuItem)`
  display: flex;
`
